/* unplugin-vue-components disabled */import { render } from "./temperatureMonitoring.vue?vue&type=template&id=7152c61f&scoped=true"
import script from "./temperatureMonitoring.vue?vue&type=script&lang=js"
export * from "./temperatureMonitoring.vue?vue&type=script&lang=js"

import "./temperatureMonitoring.vue?vue&type=style&index=0&id=7152c61f&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\北国之春\\north\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7152c61f"]])

export default __exports__